var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLirariLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 52,
    viewBox: "0 0 34 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.432366 46.5024C-0.269756 42.8333 24.0959 30.5818 24.8321 34.5618",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3363 49.3111C17.2308 49.3111 21.1984 45.3432 21.1984 40.4488C21.1984 35.5543 17.2308 31.5867 12.3363 31.5867C7.44185 31.5867 3.47412 35.5543 3.47412 40.4488C3.47412 45.3432 7.44185 49.3111 12.3363 49.3111Z",
    fill: "#010101",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66309 38.6228C7.91991 44.652 10.9375 46.5186 17.1297 47.9049",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1084 35.3894C9.49122 41.1246 13.772 43.6839 19.7544 45.2802",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84766 32.8406C12.2088 38.5282 15.1677 40.3828 21.1044 41.9781",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4399 31.5991C14.3812 35.8672 16.4939 37.169 20.8575 38.0903",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2863 33.1198C6.5496 31.809 2.46321 39.5718 7.31508 47.7529",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3087 33.1873C10.6351 34.6564 6.1329 42.1274 7.31498 47.7907",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 33.1321L7.4082 47.816",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.358 33.145C18.6757 40.0993 13.4331 47.1632 7.38379 47.8792",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.366 33.1025C23.0705 43.0773 17.3992 49.8691 7.37256 47.8717",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3492 0.0368652L21.2002 40.3918",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4052 0.585938V1.50711C21.9726 8.50945 34.7729 19.2409 32.9211 35.3015C30.3063 21.1914 26.9128 21.2603 21.4052 18.6622V1.50711C21.3797 1.19258 21.3788 0.885569 21.4052 0.585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4052 0.585938V18.6622C26.9128 21.2603 30.3063 21.1914 32.9211 35.3015C34.8561 18.5195 20.7932 7.55611 21.4052 0.585938Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8099 34.5005C25.5121 38.1696 1.14645 50.4211 0.410156 46.4412",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "12 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.2507,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLirariLogoSmall);
export default __webpack_public_path__ + "static/media/lirari-logo-small.89a5f6cb15508abc438e5fa5e7708a3e.svg";
export { ForwardRef as ReactComponent };